import {
  Tabs as MuiTabs,
  TabsProps as MuiTabsProps,
  styled,
  Tab,
  TabProps,
} from '@mui/material';

type TabOption = {
  label: string;
  tabId: number;
};

export type TabsProps = {
  value: number;
  onChange: (newValue: number) => void;
  options: TabOption[];
};

const StyledTabs = styled(MuiTabs)<MuiTabsProps>({
  '& .MuiTabs-indicator': {
    display: 'none',
  },
});

const StyledTab = styled(Tab)<TabProps>(({ theme }) => ({
  minHeight: '2.25rem',
  padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
  textTransform: 'none',
  fontSize: '0.875rem',
  fontWeight: 600,
  lineHeight: '142%',
  borderRadius: theme.shape.borderRadius,
  '&.Mui-selected': {
    color: 'white',
    backgroundColor: `rgba(${theme.vars.palette.action.selectedChannel} / ${theme.vars.palette.action.selectedOpacity})`,
  },
}));

export const Tabs = ({ value, onChange, options }: TabsProps) => {
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    onChange(newValue);
  };

  return (
    <StyledTabs value={value} onChange={handleChange}>
      {options.map((tab) => (
        <StyledTab key={tab.tabId} label={tab.label} value={tab.tabId} />
      ))}
    </StyledTabs>
  );
};
